import { css } from 'lit';
import componentStyles from '../../styles/component.styles';
import { theme } from '../../themes/theme';
export default css `
    ${componentStyles}

    :host {
        display: block;
        height: 100%;
        width: 100%;
    }

    .container {
        display: flex;
        height: 100%;
        width: 100%;
    }

    .content {
        ${theme.spacings.cssPaddingX('XXS')};

        ${theme.spacings.cssPaddingY('M')};
        ${theme.colors.cssBackground('neutral')};
        overflow-y: auto;
        flex: 1 1 0%;
    }

    @media screen and (min-width: 700px) {
        .content {
            ${theme.spacings.cssPaddingX('S')};
        }
    }

    .list {
        list-style: none;
        margin-block-start: 0;
        margin-block-end: 0;
        padding-inline-start: 0;
    }

    /* .sidebar {
        ${theme.texts.cssSubtitle};
        display: flex;
        align-items: center;
        width: 100%;
        overflow: hidden;
        height: 100%;
    }

    .sidebar:focus {
        outline: none;
    } */
`;
//# sourceMappingURL=sidebar.styles.js.map